import APIController from '../core-api-controller';

export const fetchLabWorksApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/lab_orders${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const discardLabOrderApi = (orderId, payload = {}) => {
  const path = `${APIController.endpointApi}/lab_orders/${orderId}/discard`;
  return APIController.putCallback(path, payload);
};

export const fetchLabOrderPrefillData = (leadId) => {
  const path = `${APIController.endpointApi}/lab_orders/new?lead_id=${leadId}`;
  return APIController.getApiCallback(path);
};

export const fetchLabOrderLabPanels = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/lab_orders/fetch_lab_panel${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const createLabOrderApi = (payload = {}) => {
  const path = `${APIController.endpointApi}/lab_orders`;
  return APIController.postCallback(path, payload);
};
